<template>
    <div>
        <h2 v-html="task.question"></h2>
        <div class="row">
            <div class="col-12">
                <label for="opinion">
                    Vélemény
                    <small>(maximum {{ task.taskable.text_length }} karakter)</small>
                </label>
                <textarea
                    class="form-control"
                    id="opinion"
                    name="opinion"
                    v-model="form.opinion"
                    rows="4"
                    :maxlength="task.taskable.text_length"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        task: {
            type: Object,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        }
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit('input', this.form);
            },
        },
    },
    data() {
        return {
            form: {
                task_id: this.task.id,
                opinion: null,
            },
        };
    },
    mounted() {
        this.$emit('input', this.form);
    }
}
</script>
